import { Editor } from '@tiptap/react'
import { Node as ProsemirrorNode } from 'prosemirror-model'

type FindNode = { offset: number; node: ProsemirrorNode<any> }

export const findNode = (
  editor: Editor,
  predicate: (node: ProsemirrorNode<any>) => boolean,
): FindNode | undefined => {
  let found: FindNode
  editor.state.doc.descendants((node, offset) => {
    if (predicate(node)) {
      found = { node, offset }
    }
    if (found) return false
  })
  return found
}
